import { render, staticRenderFns } from "./RevisionsDetails.vue?vue&type=template&id=6278c841&scoped=true&"
import script from "./RevisionsDetails.vue?vue&type=script&lang=js&"
export * from "./RevisionsDetails.vue?vue&type=script&lang=js&"
import style0 from "./RevisionsDetails.vue?vue&type=style&index=0&id=6278c841&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6278c841",
  null
  
)

export default component.exports